module.exports = __webpack_public_path__ + "img/rule.5d2d126b.png";